import { Badge } from 'slab'

import { type EnrollmentAutopayState } from './types'

export default function EnrollmentAutopayPill ({
  autopayState,
}: {
  autopayState: EnrollmentAutopayState | undefined,
}) {
  let text = ''
  switch (autopayState) {
    case 'on':
      text = 'Autopay: On'
      break
    case 'off':
      text = 'Autopay: Off'
      break
  }

  if (!text) {
    return
  }

  return (
    <Badge
      type={getBadgeType(autopayState)}
    >
      {text}
    </Badge>
  )
}

function getBadgeType (autopayState: EnrollmentAutopayState | undefined) {
  switch (autopayState) {
    case 'on':
      return 'success'
    case 'off':
      return 'caution'
  }
}
